/**
 * Labstep
 *
 * @module components/Tag/Table
 * @desc Table showing tags
 */

import { EntityLink } from 'labstep-web/components/Entity/Link';
import { EntityTableParamsContainer as EntityTable } from 'labstep-web/components/Entity/Table';
import { TagActionMenu } from 'labstep-web/components/Tag/Action/Menu';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { Link } from 'labstep-web/core/Link';
import type { Tag } from 'labstep-web/models/tag.model';
import { humanReadableDate } from 'labstep-web/services/date.service';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { ITagTableProps } from './types';

export const UsedByCell: React.FC<{ tag: Tag }> = ({ tag }) => (
  <Link
    unstyled
    to={`${tag.type}_index`}
    query={{ tag_id: tag.guid }}
  >
    <ActionComponent
      type="text"
      text={`${
        tag.associatedEntitiesCount
      } ${getHumanReadableEntityName(tag.type, true)} tagged`}
    />
  </Link>
);

const extraColumns = [
  {
    header: 'Created on',
    content: (tag: Tag) => humanReadableDate(tag.created_at),
    cellProps: { style: { flex: 3 } },
    sortKey: 'created_at',
  },
  {
    header: 'Times used',
    content: (tag: Tag) => <UsedByCell tag={tag} />,
    cellProps: { style: { flex: 3 } },
  },
];

export const TagTable: React.FC<ITagTableProps> = ({
  tags,
  ...rest
}) => (
  <EntityTable
    {...rest}
    id="tag-table"
    entities={tags}
    primaryColumn={{
      header: 'Name',
      content: (tag: Tag) => (
        <EntityLink
          editableName
          entity={tag}
          to={`${tag.type}_index`}
          query={{ tag_id: tag.guid }}
        />
      ),
      cellProps: { style: { flex: 3 } },
    }}
    extraColumns={extraColumns}
    actionMenu={({ entity }) => (
      <TagActionMenu tag={entity} actions={['edit', 'delete']} />
    )}
  />
);
